if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) {
        }
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.viewer.addEventListener('slideChanged', () => {
        });
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });

          if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
            this.removeListSemantic();
          }
        } else {
        }

        this.modelMap = {};
        this.contentEl = this.querySelector('.product__model-measurements-content');
        const dataScript = this.querySelector('script[id^="ModelData-"][type="application/json"]');
        if (dataScript) {
          try {
            const json = dataScript.textContent?.trim() || '{}';
            this.modelMap = JSON.parse(json);
          } catch (e) {
            this.modelMap = {};
          }
        }
      }

      onSlideChanged(event) {
        if (event.detail?.currentElement) {
          this.updateModelMeasurements(event.detail.currentElement);
        } else {
        }
        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          if (thumbnail) {
            this.setActiveThumbnail(thumbnail);
        }
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // Removed window.scrollTo: was causing page to jump to product image on mobile size change
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        this.updateModelMeasurements(activeMedia);
      }

      updateModelMeasurements(activeMediaElement) {
        const wrapper = this.querySelector('.product__model-measurements');
        const contentEl = this.contentEl || this.querySelector('.product__model-measurements-content');
        if (!wrapper || !contentEl) {
          return;
        }

        if (!activeMediaElement) {
          wrapper.classList.add('visually-hidden');
          return;
        }

        let key = activeMediaElement?.dataset?.modelKey || '';
        if (!key) {
          const img = activeMediaElement.querySelector('img');
          const src = (img?.currentSrc || img?.src || img?.getAttribute('src') || '').toLowerCase();
          const match = src.match(/_model_([a-z0-9_-]+)/i);
          if (match && match[1]) key = match[1];
        }

        if (!key || !this.modelMap) {
          wrapper.classList.add('visually-hidden');
          return;
        }

        const info = this.modelMap[key] || this.modelMap[key.toLowerCase()];
        if (!info || !info.height || !info.size) {
          wrapper.classList.add('visually-hidden');
          return;
        }

        let p = contentEl.querySelector('p');
        if (!p) {
          p = document.createElement('p');
          contentEl.innerHTML = '';
          contentEl.appendChild(p);
        }
        p.textContent = `Model is ${info.height} and wearing size ${String(info.size).toUpperCase()}`;

        wrapper.classList.remove('visually-hidden');
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
